import React, { Component } from "react";

import CommonService from "services/common";
import Utils from "utils";
import ContactView from "./view";

class Contact extends Component {
  state = {
    name: "",
    email: "",
    message: "",
    success: false,
    error: false,
    captchaVerified: false,
  };

  verifyCaptcha = () => this.setState({ captchaVerified: true });

  submit = () => {
    const { name, email, message, captchaVerified } = this.state;

    if (
      !Utils.validator(name) ||
      !Utils.validator(email) ||
      !Utils.validator(message) ||
      !captchaVerified
    ) {
      this.setState({ error: true });
      window.scrollTo(0, 0);
    } else {
      CommonService.contact({ name, email, message }).then((res) => {
        if (res === "success")
          this.setState({
            success: true,
            name: "",
            email: "",
            message: "",
            error: false,
          });
        else this.setState({ error: true });
        window.scrollTo(0, 0);
      });
    }
  };

  setFormData = (type, value) => this.setState({ [type]: value });

  render() {
    const { success, error, name, email, message } = this.state;
    return (
      <ContactView
        submit={this.submit}
        setFormData={this.setFormData}
        success={success}
        error={error}
        verifyCaptcha={this.verifyCaptcha}
        name={name}
        email={email}
        message={message}
      />
    );
  }
}

export default Contact;
